const emailRegex = new RegExp(/\S+@\S+\.\S+/);

export const requiredValidator = (value, t) =>
  value ? "" : t("field_is_required");

export const emailValidator = (value, t) => {
  if (!value || value.trim() === "") {
    return "";
  }
  return emailRegex.test(value) ? "" : t("email_is_not_valid");
};

export const availabilityValidator = (locationValue, value, t) =>
  locationValue && value === false ? t("location_is_unavailable") : "";
